import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import TerminosCondiciones from '../../TerminosCondiciones';

const IntegradorComponentes = (props) => {
    const [aceptoTerminos, setAceptoTerminos] = useState(false);
    const { marca, servicio, servicioFirebase, componente } = props;
    var Componente = componente;
    useEffect(() => {
        return () => { };
    }, []);
    return (
        aceptoTerminos === false ?
        <TerminosCondiciones marca={marca} servicio={servicio} servicioFirebase={servicioFirebase} callbackAceptoTerminos={setAceptoTerminos} mostrarMenu={marca !== 'vw'} mostrarFooter={marca !== 'vw'}/>
        :
        <Componente {...props} />
        )
}
export default withRouter(IntegradorComponentes);